/* @ngInject */
const sterileLocal = (

) => {
  const self = {}

  return self
}
export default sterileLocal



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/scrapping/sterile/services/local.service.js